import React, { useState } from 'react';
import { connect } from 'react-redux';

import { cloneDeep } from 'lodash';
import clsx from 'clsx';

import TextField from '@material-ui/core/TextField';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import BobModal from '../../../components/BobModal';

import * as BasAgentActions from '../../../actions/basAgentActions';

import * as classes from './AssignBasAgentModal.module.css';

const AssignBasAgentModal = ({
    activeNavCompany,
    agent,
    setAssignAgentModalOpen,
    updateBasAgent,
    ...props
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [serialNumber, setSerialNumber] = useState('');

    const handleSerialNumberChange = event => {
        setSerialNumber(event.target.value);
    };

    const handleAssignAgent = async () => {
        let updatedAgent = cloneDeep(agent);

        updatedAgent.serialNumber = serialNumber;
        setIsLoading(true);
        let isUpdated = await updateBasAgent(activeNavCompany.id, updatedAgent.id, updatedAgent);
        setIsLoading(false);

        if (isUpdated) setAssignAgentModalOpen(false);
    };

    const isValid = serialNumber => {
        const regex = /^[SH][2-9A-Z]{4}-[2-9A-Z]{5}-[2-9A-Z]{5}-[2-9A-Z]{5}-[2-9A-Z]{5}$/g;

        return !regex.test(serialNumber);
    };

    return (
        <BobModal
            title={'Assign Agent'}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => setAssignAgentModalOpen(false)}
        >
            <div className={classes.ModalBody}>
                <div className={classes.NamePanel}>
                    <div className={classes.Title}>
                        Agent Name
                    </div>
                    <div className={classes.IntegrationName}>
                        {agent.name}
                    </div>
                </div>
                <div className={classes.InputPanel}>
                    <TextField
                        key="New Agent Name"
                        id="standard-required"
                        label={<span>Serial Number<span className={classes.Required}> *</span></span>}
                        placeholder="Enter"
                        value={serialNumber}
                        onChange={handleSerialNumberChange}
                        size="small"
                        inputProps={{
                            style: { fontSize: 14 }
                        }}
                        InputLabelProps={{
                            className: classes.NameLabel
                        }}
                        className={classes.NameInput}
                        variant="outlined"
                    />
                    <div className={classes.HelperText}>
                        <i className={clsx('fas fa-info-circle', classes.HelpIcon)} />
                        <div>
                            <div>Please enter the Serial Number of the Hardware or Software BAS Agent you would like to assign.</div>
                            <p>Expected Format: XXXXX-XXXXX-XXXXX-XXXXX-XXXXX</p>
                        </div>
                    </div>
                </div>
                <div className={classes.ButtonPanel}>
                    <BobCancelButton
                        disabled={isLoading}
                        onClick={() => setAssignAgentModalOpen(false)}
                        className={classes.CancelButton}
                        label={'Cancel'}
                    />
                    <BobConfirmButton
                        disabled={isValid(serialNumber) || isLoading}
                        onClick={() => handleAssignAgent()}
                        className={isValid(serialNumber) || isLoading ? classes.DisabledButtons : classes.Buttons}
                        label={'Rename'}
                        iconSize={15}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </BobModal>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
});

const mapDispatchToProps = {
    ...BasAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignBasAgentModal);
